import React from "react";

import DropdownMenuItem from "../MenuItem/MenuItem";

import styles from "./MenuSection.module.css";

export interface Item<ID> {
  id: ID;
  name: string;
  isFavorite: boolean;
}

interface Props<ID extends string, T extends Item<ID>> {
  currentId: ID;
  setId: (id: ID) => void;
  header: string;
  items: T[];
  isLoading?: boolean;
}

const DropdownMenuSection = <ID extends string, T extends Item<ID>>({
  currentId,
  setId,
  header,
  items,
  isLoading,
}: Props<ID, T>) => {
  const handleOnClick = (id: ID) => () => setId(id);
  return (
    <div className={styles.listContainer}>
      <div className={styles.listHeader}>{header}</div>
      <div className={styles.scrollContainer}>
        {isLoading ? (
          <div className={styles.loadingText}>...loading</div>
        ) : (
          items.map((el) => (
            <DropdownMenuItem
              key={el.id}
              label={el.name}
              isFavorite={el.isFavorite}
              isChecked={el.id === currentId}
              onClick={handleOnClick(el.id)}
            />
          ))
        )}
      </div>
    </div>
  );
};

export default DropdownMenuSection;
